import React from 'react';
import { Navigate } from 'react-router-dom';
import { useLanguage } from '../components/LanguageContext';

const RejsetipsGuidePage = () => {
  const { language, getLocalizedPath } = useLanguage();
  const basePath = getLocalizedPath('traveltips', language);
  return <Navigate to={`${basePath}?article=hvad-skal-du-huske-paa-ferie-som-koerestolsbruger`} replace />;
};

export default RejsetipsGuidePage;
